class RebuyYmalPricing {
  constructor() {
    this.widgetId = '234632';

    this.discountTiers = {
      1: 10,
      2: 15,
      3: 20
    };

    this.init();
  }

  init() {
    document.addEventListener('rebuy.init', (event) => {
        const { widget } = event.detail;

        if (!widget || widget.id !== this.widgetId) return;

        this.widget = window.Rebuy.widgets.find(widget => widget.id === this.widgetId);

        console.log('Rebuy YMAL widget initialized:', this.widget);

        this.updateYmalPricing();
        this.setupCartListener();

    });
 }

  setupCartListener() {
    document.addEventListener('rebuy:cart.change', async () => {
        await this.refreshBundleState();
        await this.updateYmalPricing();
    });
  }

  getBundleState() {
    const cartState = document.querySelector(
        '#bundle-discount-cart-state'
    );

    if (!cartState) {
        return {
        hasBundleTrigger: false,
        accessoryCount: 0
        };
    }

    return {
        hasBundleTrigger:
        cartState.dataset.hasBundleTrigger === 'true',

        accessoryCount:
        Number(cartState.dataset.eligibleAccessoryCount || 0)
    };
  }

  getDiscountTier(accessoryCount, hasBundleTrigger) {
    if (!hasBundleTrigger) {
      return 0;
    }

    if (accessoryCount >= 2) {
      return this.discountTiers[3];
    }

    if (accessoryCount === 1) {
      return this.discountTiers[2];
    }

    return this.discountTiers[1];
  }

  async updateYmalPricing() {
    const bundleState = this.getBundleState();

    const discount = this.getDiscountTier(
      bundleState.accessoryCount,
      bundleState.hasBundleTrigger
    );

    const products = await this.getYmalProducts();
    const cards = document.querySelectorAll(
        '#rebuy-widget-234632 .rebuy-product-block'
    );

 
    products.forEach(product => {
        const variant = product.variants?.[0];
     
        if (!variant) return;
        
        const price = Number(variant.price) * 100;

        const eligible = product.metafields?.custom?.is_bundle_discount_eligible === 'true';
        const card = [...cards].find(card => {
            return (
            this.getCardVariantId(card) === Number(variant.id)
            );
        });

        if (!card) return;

    
        if (eligible && discount > 0) {
            const discountedPrice = this.getDiscountedPrice(
                price,
                discount
            );

            this.updateCardPrice(
                card,
                price,
                discountedPrice,
                discount
            );
        } else {
            this.updateCardPrice(
                card,
                price,
                price,
                0
            );
        }
    });
  }

  async getYmalProducts() {
    return new Promise((resolve) => {
        this.widget.getWidgetProducts((products) => {
            resolve(products);
        });
    });
  }

  getDiscountedPrice(price, discount) {
    return Math.round(price * (1 - discount / 100));
  }

 updateCardPrice(card, originalPrice, discountedPrice, discount) {
  const priceContainer = card.querySelector('.rebuy-product-price');

  if (!priceContainer) return;

  if (discount > 0) {
    // priceContainer.innerHTML = `
    //   <div class="ctl-rebuy-price">
    //     <span class="ctl-rebuy-price-current">
    //       ${this.formatMoney(discountedPrice)}
    //     </span>

    //     <span class="ctl-rebuy-discount-badge">
    //       ${discount}% off
    //     </span>
    //   </div>
    // `;
    priceContainer.innerHTML = `
      <div class="ctl-rebuy-price">
      
        <span class="ctl-rebuy-price-current">
          ${this.formatMoney(discountedPrice)}
        </span>
        <span class="ctl-rebuy-price-original">
          ${this.formatMoney(originalPrice)}
        </span>
      </div>
    `;

    return;
  }

  priceContainer.innerHTML = `
    <div>
      <span class="rebuy-money">
        <span class="sr-only">Price</span>
        <span>${this.formatMoney(originalPrice)}</span>
      </span>
    </div>
  `;
}

  formatMoney(cents) {
    return `${new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(cents / 100)}`;
  }

  getCardVariantId(card) {
    const link = card.querySelector(
        '.rebuy-product-title-link'
    );

    if (!link) return null;

    const url = new URL(link.href, window.location.origin);

    return Number(url.searchParams.get('variant'));
  }

  async refreshBundleState() {
    const response = await fetch(window.location.href);

    if (!response.ok) {
        throw new Error('Failed to refresh bundle state.');
    }

    const html = await response.text();

    const doc = new DOMParser().parseFromString(
        html,
        'text/html'
    );

    const newState = doc.querySelector(
        '#bundle-discount-cart-state'
    );

    const currentState = document.querySelector(
        '#bundle-discount-cart-state'
    );

    if (!newState || !currentState) return;

    currentState.dataset.hasBundleTrigger =
        newState.dataset.hasBundleTrigger;

    currentState.dataset.eligibleAccessoryCount =
        newState.dataset.eligibleAccessoryCount;
  }

  waitForWidget(timeout = 10000) {
    return new Promise((resolve, reject) => {
        const start = performance.now();

        const findWidget = () => {
        const widget = window.Rebuy?.widgets?.find(
            widget => widget.id === this.widgetId
        );

        if (widget) {
            resolve(widget);
            return;
        }

        if (performance.now() - start >= timeout) {
            reject(
            new Error(`Rebuy widget ${this.widgetId} was not found.`)
            );
            return;
        }

        requestAnimationFrame(findWidget);
        };

        findWidget();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new RebuyYmalPricing();
});